var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge mr-2",class:_vm.stateobj.classe ? _vm.stateobj.classe : 'bg-secondary'},[_vm._v(_vm._s(_vm.stateobj.label ? _vm.stateobj.label : 'Non disponible'))])
}
var staticRenderFns = []

export { render, staticRenderFns }